import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import all from 'prop-types-extra/lib/all';
import SafeAnchor from '../bootstrap/SafeAnchor';
import { bsClass, prefix, splitBsPropsAndOmit } from '../bootstrap/utils/bootstrapUtils';
import createChainedFunction from '../bootstrap/utils/createChainedFunction';
import { jsx as _jsx } from "react/jsx-runtime";
class MenuItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    const {
      href,
      disabled,
      onSelect,
      eventKey
    } = this.props;
    if (!href || disabled) {
      event.preventDefault();
    }
    if (disabled) {
      return;
    }
    if (onSelect) {
      onSelect(eventKey, event);
    }
  }
  render() {
    const {
      active,
      disabled,
      divider,
      header,
      onClick,
      className,
      style,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsPropsAndOmit(props, ['eventKey', 'onSelect']);
    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return /*#__PURE__*/_jsx("li", {
        ...elementProps,
        role: "separator",
        className: clsx(className, 'divider'),
        style: style
      });
    }
    if (header) {
      return /*#__PURE__*/_jsx("li", {
        ...elementProps,
        className: clsx(className, prefix(bsProps, 'header')),
        style: style
      });
    }
    return /*#__PURE__*/_jsx("li", {
      role: "presentation",
      className: clsx(className, {
        active,
        disabled
      }),
      style: style,
      children: /*#__PURE__*/_jsx(SafeAnchor, {
        ...elementProps,
        role: "menuitem",
        tabIndex: "-1",
        onClick: createChainedFunction(onClick, this.handleClick)
      })
    });
  }
}
MenuItem.defaultProps = {
  divider: false,
  disabled: false,
  header: false
};
export default bsClass('dropdown', MenuItem);